import EmailEditor from './js/EmailEditor';

export default EmailEditor;
